<div class="section">
    <!-- container -->
    <div class="container2">
        <!-- row -->
        <div style="    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
        background: white;" class="row">
            <!-- Product main img -->
            <div class="col-md-5">
                <div class="productmain">
                    <!-- <a [routerLink]="['/product-detail', product.skuCode]"> -->
                        <app-product-image [imageUrl]="selectedImage" [packSize]="product.packSize"
                        [capacity]="product.capacity" [discountPercentage]="product.discountPercentage"
                        [isNewProduct]="product.isNewProduct">
                    </app-product-image>
                    <div class="container_upload" *ngIf='noImageRole && this.selectedImage !== "" && hasValidToken && this.selectedImage !== this.productImages[0]'>
                        <div class="button-group">
                            <button mat-raised-button class="login-for-price" style="visibility: hidden;">Select File</button>
                            <button mat-raised-button class="login-for-price" (click)="setCoverImage(selectedImage)">Set As Cover Image</button>
                        </div>
                    </div>

                    <div class="separator"></div>



                    <div style="box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1p;" class="col-md-3"  *ngFor="let url of productImages;let i = index" (click)="selectedImage = url">
                        <img [src]="url" alt="" class="thumbnail"
                            [ngStyle]="{'outline': selectedImage === url ? '0px solid red' : null }" (error)="productImages[i] = 'https://sgresources.supergrp.net/SGConvenience/Wholesale/Brand/NoImage.png'">
                    </div>


                    <!-- </a> -->
                </div>
            </div>

                <!--
            {{product | json}} -->
            <!-- Product details -->
            <div class="col-md-1"></div>
            <div class="col-md-6">
                <div class="product-details">
                    <h2 class="product-name">{{ product.skuDescription }}</h2>
                    <div *ngIf="hasValidToken && product.discountPriceExcl > 0">
                        <h4 class="product-price">
                            {{ product.discountPriceExcl * userQuantity | currency:'R' | amountFormat }} Excl
                            <del class="product-old-price">{{ product.listPriceExcl | currency:'R' | amountFormat }}
                            </del>
                        </h4>
                        <h4 class="product-incl-price">{{ product.discountPriceIncl * userQuantity | currency:'R' |
                            amountFormat }} Incl </h4>
                    </div>
                    <div *ngIf="hasValidToken && product.discountPriceExcl === 0 || product.discountPriceExcl === null">
                        <h4 class="product-price">{{ product.listPriceExcl * userQuantity | currency:'R' | amountFormat
                            }} Excl </h4>
                        <h4 class="product-incl-price">{{ product.listPriceIncl * userQuantity | currency:'R' |
                            amountFormat }} Incl </h4>
                    </div>
                    <div>
                        <span class="product-available">
                            Availability: {{product.stockOnHand > 0 ? 'In stock' : 'Out of stock'}}
                        </span>
                    </div>
                    <div><span class="product-available-code">{{ product.skuCode }}</span>
                    </div>

                    <p><br>
                        <!-- {{ product.skuDescription }}<br> -->
                        <br>
                    </p>


                    <div *ngIf="!hasValidToken; else showCart">
                        <a [routerLink]="['/login']">
                            <button class="login-for-price"> LOG IN TO VIEW PRICES
                            </button>
                        </a>
                    </div>

                    <div *ngIf="noImageRole && hasValidToken">
                        <div class="separator"></div>

                        <div>
                            <p><b>Image Upload Guidelines:</b></p>
                            <p>* Images will be automatically uploaded.</p>
                            <p>* Accepted format: PNG.</p>
                            <p>* Maximum file size: 1MB.</p>
                        </div>

                        <div class="container_upload">
                            <input
                                type="file"
                                #fileInput
                                style="display: none"
                                (change)="onFileSelected($event)"
                                accept=".png*"
                            />
                            <div class="button-group">
                                <button mat-raised-button class="login-for-price" (click)="fileInput.click()">Select File</button>
                                <!-- <button mat-raised-button class="login-for-price" (click)="updateSelectedImageSrc()">Upload File</button> -->
                            </div>
                            <div class="button-group">
                                <button mat-raised-button *ngIf="product.extendedData === undefined && !isEditing && noImageRole && hasValidToken" class="login-for-price" (click)="editDescription(product.skuDescription)" >Edit Description</button>
                                <button mat-raised-button *ngIf="product.extendedData !== undefined && !isEditing && noImageRole && hasValidToken" class="login-for-price" (click)="editDescription(product.extendedData?.siloMarketingDescription)" >Edit Description</button>
                            </div>

                            <div class="status-container_upload">
                                <p><b>{{uploadStatus}}</b></p>
                            </div>

                            <!-- <div class="button-group">
                                <button mat-raised-button class="login-for-price" (click)="saveImagesToFolder()">SAVE</button>
                                <button mat-raised-button class="login-for-price" (click)="clear()">CLEAR</button>
                            </div> -->
                        </div>
                    </div>

                </div>
            </div>
            <!-- /Product details -->

            <!-- Product tab -->
            <div class="col-md-12">
                <div id="product-tab">
                    <!-- product tab nav -->
                    <ul class="tab-nav">
                        <li class="active"><a data-toggle="tab" href="#tab1" aria-expanded="true">Description</a></li>
                        <li class=""><a data-toggle="tab" href="#tab2" aria-expanded="false">Additional Information</a></li>
                    </ul>
                    <!-- /product tab nav -->

                    <!-- product tab content -->
                    <div class="tab-content">
                        <!-- tab1  -->
                        <div id="tab1" class="tab-pane fade active in">
                            <div class="row">
                                <div class="col-md-12">
                                    <p *ngIf='product.extendedData === undefined'>
                                        <span *ngIf="!isEditing">{{ product.skuDescription }}</span>
                                    </p>
                                    <p *ngIf='product.extendedData !== undefined'>
                                        <span *ngIf="!isEditing">{{ product.extendedData?.siloMarketingDescription }}</span>
                                    </p>

                                    <div *ngIf="isEditing" style="width: 100%;">
                                        <textarea
                                            [(ngModel)]="editingDescription"
                                            rows="5"
                                            style="width: 100%; box-sizing: border-box; padding: 10px; font-size: 1rem; border: 1px solid #dadada; border-radius: 4px;">
                                        </textarea>
                                        <div class="button-group" style="margin-top: 10px;">
                                            <button mat-raised-button class="login-for-price" (click)="undoDescription()">Undo</button>
                                            <button mat-raised-button class="login-for-price" (click)="saveDescription()">Save</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- /tab1  -->

                        <!-- tab2  -->
                        <div id="tab2" class="tab-pane fade">
                            <div class="row">
                                <div class="col-md-12">
                                    <div *ngIf='product.extendedData !== undefined'>
                                        <h4>Product Details</h4>
                                    </div>
                                    <table
                                        style="width:100%; text-align: left; border: 1px solid #dadada; border-collapse: collapse;"
                                        *ngIf='product.extendedData !== undefined'>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.packConfiguration !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Pack Configuration
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.packConfiguration }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.productWidthMM !== "" || product.extendedData?.productDepthMM !== "" || product.extendedData?.productHeightMM !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;"
                                                colspan="2">
                                                Product Size (MM)
                                            </th>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.productWidthMM !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Width
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.productWidthMM }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.productDepthMM !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Depth
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.productDepthMM }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.productHeightMM !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Height
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.productHeightMM }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingSize !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Size
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingSize }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingSizeUOM !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Size (UOM)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingSizeUOM }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.whatsInTheBox !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                What's In The Box
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.whatsInTheBox }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.usageInstructions !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Usage Instructions
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.usageInstructions }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.storageInstructions !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Storage Instructions
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.storageInstructions }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.serviceGuaranteeWarranty !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Service Guarantee Warranty
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.serviceGuaranteeWarranty }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.packagingMaterial !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Packaging Material
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.packagingMaterial }} </p>
                                            </td>
                                        </tr>
                                    </table><br />

                                    <div *ngIf='product.extendedData !== undefined'>
                                        <h4
                                            *ngIf='product.extendedData?.generalWarnings !== "" || product.extendedData?.allergenWarnings !== "" || product.extendedData?.commonAllergens !== ""'>
                                            Product Warnings</h4>
                                    </div>
                                    <table
                                        style="width:100%; text-align: left; border: 1px solid #dadada; border-collapse: collapse;"
                                        *ngIf='product.extendedData !== undefined'>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.generalWarnings !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                General Warnings
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.generalWarnings }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.allergenWarnings !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Allergen Warnings
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.allergenWarnings }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.commonAllergens !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Common Allergens
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.commonAllergens }} </p>
                                            </td>
                                        </tr>
                                    </table><br />
                                    <div *ngIf='product.extendedData !== undefined'>
                                        <h4>Product Nutritional Details</h4>
                                    </div>
                                    <table
                                        style="width:100%; text-align: left; border: 1px solid #dadada; border-collapse: collapse;"
                                        *ngIf='product.extendedData !== undefined'>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.ingredients !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Ingredients
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.ingredients }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.organic !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Organic
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.organic }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.vegan !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Vegan
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.vegan }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.vegetarian !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Vegetarian
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.vegetarian }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.glutenFree !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                GlutenFree
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.glutenFree }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.freeRange !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                FreeRange
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.freeRange }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.otherClaims !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Other Claims
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.otherClaims }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.halaal !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Halaal
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.halaal }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.kosher !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Kosher
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.kosher }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.otherEndorsements !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Other Endorsements
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.otherEndorsements }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.alcoholPercentage !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Alcohol Percentage (%)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.alcoholPercentage }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingSize !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Size
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingSize }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingSizeUOM !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Size (UOM)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingSizeUOM }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.energy100gKJ !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Energy 100g (KJ)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.energy100gKJ }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingEnergykJ !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Energy (kJ)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingEnergykJ }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.carbohydrate100gG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Carbohydrate 100g (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.carbohydrate100gG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingCarbohydrateG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Carbohydrate (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingCarbohydrateG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.totalSugar100gG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Total Sugar 100g (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.totalSugar100gG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingOfWhichTotalSugarG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Of Which Total Sugar (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingOfWhichTotalSugarG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.totalFat100gG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Total Fat 100g (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.totalFat100gG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingTotalFatG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Total Fat (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingTotalFatG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.saturatedFat100gG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Saturated Fat 100g (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.saturatedFat100gG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingSaturatedFatG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Saturated Fat (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingSaturatedFatG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.monounsaturatedFat100gG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Monounsaturated Fat 100g (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.monounsaturatedFat100gG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingMonounsaturatedFatG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Monounsaturated Fat (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingMonounsaturatedFatG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.polyunsaturatedFat100gG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Polyunsaturated Fat 100g (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.polyunsaturatedFat100gG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingPolyunsaturatedFatG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Polyunsaturated Fat (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingPolyunsaturatedFatG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.transFat100gG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Trans Fat 100g (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.transFat100gG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingTransFatG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Trans Fat (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingTransFatG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.protein100gG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Protein 100g (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.protein100gG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingProteinG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Protein (G)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingProteinG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.dietaryFibre100g !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Dietary Fibre 100g
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.dietaryFibre100g }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingDietaryFibre !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Dietary Fibre
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingDietaryFibre }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.cholestrol100gMG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Cholestrol 100g (MG)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.cholestrol100gMG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingCholestrolMG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Cholestrol (MG)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingCholestrolMG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.omega3FattyAcids100gMG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Omega3 Fatty Acids 100g (MG)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.omega3FattyAcids100gMG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingOmega3FattyAcidsMG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Omega3 Fatty Acids (MG)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingOmega3FattyAcidsMG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.totalSodium100gMG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Total Sodium 100g (MG)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.totalSodium100gMG }} </p>
                                            </td>
                                        </tr>
                                        <tr style="border: 1px solid #dadada;"
                                            *ngIf='product.extendedData?.servingTotalSodiumMG !== ""'>
                                            <th style="background-color: #f4f4f4; text-align: center; padding: 8px;">
                                                Serving Total Sodium (MG)
                                            </th>
                                            <td style="width:70%">
                                                <p>{{ product.extendedData?.servingTotalSodiumMG }} </p>
                                            </td>
                                        </tr>
                                    </table><br />
                                </div>
                            </div>
                        </div>
                        <!-- /tab2  -->

                        <!-- tab3  -->

                        <!-- /tab3  -->
                    </div>
                    <!-- /product tab content  -->
                </div>
            </div>
            <!-- /product tab -->
        </div>
        <!-- /row -->
    </div>
    <!-- /container -->
    <br />
</div>

<div class="section" hidden>
    <!-- container -->
    <div class="container">
        <!-- row -->
        <div class="row">

            <div class="col-md-12">
                <div class="section-title text-center">
                    <h3 class="title">Customers also bought</h3>
                </div>
            </div>

            <!-- product -->
            <div class="col-md-3 col-xs-6">
                <div class="product"> <a [routerLink]="['/']">
                        <div class="product-img"><img src="../../../../assets/images/Beer.png" alt="">
                            <div class="product-label"> <span class="sale">-30%</span> <span class="new">NEW</span>
                            </div>
                        </div>
                    </a>
                    <div class="product-body">
                        <p class="product-category">Category</p>
                        <h3 class="product-name"><a [routerLink]="['/']">product name goes here</a></h3>
                        <h4 class="product-price">R90.00 <del class="product-old-price">R120.00</del></h4>
                        <div class="linegrey"></div>
                        <div class="product-btns"> <a [routerLink]="['/']">
                                <div class="addtocart"> ADD TO CART </div>
                            </a>
                            <button class="add-to-wishlist"><i class="fa fa-heart-o"></i><span class="tooltipp">add to
                                    wishlist</span></button>
                            <button class="quick-view"><i class="fa fa-eye"></i><span class="tooltipp">quick
                                    view</span></button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /product -->

            <!-- product -->
            <div class="col-md-3 col-xs-6">
                <div class="product"> <a [routerLink]="['/']">
                        <div class="product-img"><img src="../../../../assets/images/Beer.png" alt=""></div>
                    </a>
                    <div class="product-body">
                        <p class="product-category">Category</p>
                        <h3 class="product-name"><a [routerLink]="['/']">product name goes here</a></h3>
                        <h4 class="product-price">R90.00</h4>
                        <div class="linegrey"></div>
                        <div class="product-btns"> <a [routerLink]="['/']">
                                <div class="addtocart"> ADD TO CART </div>
                            </a>
                            <button class="add-to-wishlist"><i class="fa fa-heart-o"></i><span class="tooltipp">add to
                                    wishlist</span></button>
                            <button class="quick-view"><i class="fa fa-eye"></i><span class="tooltipp">quick
                                    view</span></button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /product -->

            <div class="clearfix visible-sm visible-xs"></div>

            <!-- product -->
            <div class="col-md-3 col-xs-6">
                <div class="product"> <a [routerLink]="['/']">
                        <div class="product-img"><img src="../../../../assets/images/Beer.png" alt="">
                            <div class="product-label"> <span class="new">(16 x 150g)</span> </div>
                        </div>
                    </a>
                    <div class="product-body">
                        <p class="product-category">Category</p>
                        <h3 class="product-name"><a [routerLink]="['/']">product name goes here</a></h3>
                        <h4 class="product-price">R90.00</h4>
                        <div class="linegrey"></div>
                        <div class="product-btns"> <a [routerLink]="['/']">
                                <div class="addtocart"> ADD TO CART </div>
                            </a>
                            <button class="add-to-wishlist"><i class="fa fa-heart-o"></i><span class="tooltipp">add to
                                    wishlist</span></button>
                            <button class="quick-view"><i class="fa fa-eye"></i><span class="tooltipp">quick
                                    view</span></button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /product -->

            <!-- product -->
            <div class="col-md-3 col-xs-6">
                <div class="product"> <a [routerLink]="['/']">
                        <div class="product-img"><img src="../../../../assets/images/Beer.png" alt=""></div>
                    </a>
                    <div class="product-body">
                        <p class="product-category">Category</p>
                        <h3 class="product-name"><a [routerLink]="['/']">product name goes here</a></h3>
                        <h4 class="product-price">R90.00</h4>
                        <div class="linegrey"></div>
                        <div class="product-btns"> <a [routerLink]="['/']">
                                <div class="addtocart"> ADD TO CART </div>
                            </a>
                            <button class="add-to-wishlist"><i class="fa fa-heart-o"></i><span class="tooltipp">add to
                                    wishlist</span></button>
                            <button class="quick-view"><i class="fa fa-eye"></i><span class="tooltipp">quick
                                    view</span></button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /product -->

        </div>
        <!-- /row -->
    </div>
    <!-- /container -->
</div>


<div class="spinner-wrapper" *ngIf="isLoading">
    <app-spinner></app-spinner>
</div>


<ng-template #showCart>
    <div class="add-to-cart">
        <div class="qty-label">
            <!-- Qty-->
            <div class="input-number">
                <span class="qty-down"
                    (click)="quantity.value > 1 ? userQuantity = +quantity.value - 1 : quantity.value">-</span>
                <input type="number" min="1" [(ngModel)]="userQuantity" id="quantity" name="quantity" #quantity
                    onkeypress="return event.charCode >= 48" oninput="value = value < 1 ? 1 : value">
                <span class="qty-up" (click)="userQuantity = +quantity.value + 1">+</span>
            </div>

        </div>
        <button class="addtocarttwo" (click)="addProductItemToCart(product,quantity.value)">add to
            cart</button>
        <button *ngIf="onWishlist()" class="wishlist-button" (click)="removeFromWishList(product)">
            <i class="fa fa-heart" style="color: red"></i><span class="tooltipp">remove from
                wishlist</span>
        </button>
        <button *ngIf="!onWishlist()" class="wishlist-button" (click)="addItemToWishlist(product, quantity.value)">
            <i class="fa fa-heart" style="color: silver"></i><span class="tooltipp">add to
                wishlist</span>
        </button>
    </div>
</ng-template>
